<template>
  <div>
    <el-form :model="queryForm" label-width="80px">
      <div class="tab_radio">
        <el-radio-group v-model="queryForm.type" style="margin-bottom:30px;float:left;display:inline-block;" text-color="#00a6ff">
          <el-radio-button label="DAY">今日</el-radio-button>
          <el-radio-button label="MONTH">本月</el-radio-button>
          <el-radio-button label="YEAR">本年</el-radio-button>
        </el-radio-group>
      </div>

      <div>
        <el-form-item label="开始时间" style="float:left">
          <el-date-picker v-model="queryForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :clearable="false" />
        </el-form-item>
        <el-form-item label="结束时间" style="float:left">
          <el-date-picker v-model="queryForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :clearable="false" />
        </el-form-item>
      </div>

      <el-form-item style="display:inline-block;">
        <!-- <el-button @click="more" plain>{{ isPart ? "更多" : "隐藏" }}</el-button> -->
        <el-button type="primary" plain @click="query(true)">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
        <el-button type="primary" plain @click="back">返回</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="company">
    <ul>
      <li><i class="iconfont icon-company"></i>公司名称：{{detail.companyName}}</li>
      <li><i class="iconfont icon-license"></i>组织机构代码：{{detail.institutionCode}}</li>
      <li><i class="iconfont icon-contact"></i>联 系 人：{{detail.contactUser}}</li>
      <li><i class="iconfont icon-phone"></i>电 话：{{ detail.contactNum }}</li>
      <li><i class="iconfont icon-email"></i>邮 箱：{{ detail.email }}</li>
    </ul>
  </div> -->
    <div class="box">
      <div class="company">
        <div style="font-size:12px;">
          <span style="color:#999999;">企业名称</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.companyName }}</span>
        </div>
        <div style="font-size:12px;">
          <span style="color:#999999;">组织机构代码</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.institutionCode }}</span>
        </div>
        <div style="font-size:12px;">
          <span style="color:#999999;">联 系 人</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.contactUser }}</span>
        </div>
        <div style="font-size:12px;">
          <span style="color:#999999;">电 话</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.contactNum }}</span>
        </div>
        <div style="font-size:12px;">
          <span style="color:#999999;">邮 箱</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.email }}</span>
        </div>
      </div>
      <div class="other-info">
        <div style="width:16%">
          <div>
            <i class="iconfont icon-iconset0216" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">充电度数</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFloat(detail.totalChargingDegree) }}</span>
            <span style="font-size:14px;color:#333333;">度</span>
          </div>
        </div>
        <!-- <div style="width:16%">
          <div>
            <i class="iconfont icon-dianfei" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">电费</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFloat(detail.totalElectricityBill) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:16%">
          <div>
            <i class="iconfont icon-fuwufei" style="color:#00a6ff" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">服务费</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFloat(detail.totalServiceCharge) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div> -->
        <div style="width:16%">
          <div>
            <i class="iconfont icon-yingshouzhangkuan" style="color:#f4ea2a" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">应付金额</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFloat(detail.totalPayableAmount) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:16%">
          <div>
            <i class="iconfont icon-lirunbiao" style="color:#f4ea2a" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">实付核对</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFloat(detail.totalAmountReceivable) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:16%">
          <div>
            <i class="iconfont icon-shishoufeiyong" style="color:#f4ea2a" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">实付金额</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFixed2(detail.totalActualAmount) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:16%">
          <div>
            <i class="iconfont icon-qianbao" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">企业钱包余额</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFixed2(detail.totalUnitBalance) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
        <div style="width:16%">
          <div>
            <i class="iconfont icon-qianbao1" />
            <span style="font-size:16px;color:#333333;margin-left:6px;">个人钱包余额</span>
          </div>
          <div>
            <span style="font-size:32px;color:#1890FF;font-weight:500;">{{ getFixed2(detail.totalPersonBalance) }}</span>
            <span style="font-size:14px;color:#333333;">元</span>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户" name="user" />
        <el-tab-pane label="订单" name="order" />
        <el-tab-pane label="财务流水" name="summary" />
        <el-tab-pane label="对账单" name="bill">
          <el-button plain type="primary" style="float: right;" icon="el-icon-download" permission="financial.summary.export" @click="exportOrder">导出</el-button>
        </el-tab-pane>
      </el-tabs>

      <template v-if="activeName == 'user'">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" align="center" width="50" label="序号" />
          <el-table-column label="用户账号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.loginName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业账户余额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.unitBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="个人账户余额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.personBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="电费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.electricityBill) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.serviceCharge) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="应付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.payableAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付核对" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.amountReceivable) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.actualAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电次数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.count }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-if="activeName == 'order'">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" align="center" width="50" label="序号" />
          <el-table-column label="订单编号" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="goToDetail(scope.row.id)"> {{ scope.row.startChargeSeq }} </el-button>
            </template>
          </el-table-column>
          <el-table-column label="用户归属企业" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.organizationName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户账号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.loginName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.plateNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电度数" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.chargingDegree }}</span>
            </template>
          </el-table-column>
          <el-table-column label="电费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.electricityBill) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.serviceCharge) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="应付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.payableAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付核对" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.amountReceivable) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getScaleNum(scope.row.actualAmount,2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付方式" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.paymentType==0 ? '个人钱包' : scope.row.paymentType==1 ? '企业钱包' :'个人钱包、企业钱包' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" align="center">
            <template slot-scope="scope">
              <span>{{ getStatus(scope.row.orderStatus) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-if="activeName == 'summary'">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" align="center" width="50" label="序号" />
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? '个人充值' : scope.row.type == 2 ? '个人退款' : scope.row.type == 3 ? '个人消费' : scope.row.type == 4 ? '平台充值' : scope.row.type == 5 ? '平台扣款' : '补贴消费' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户账号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.loginName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产生额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.money) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业账户余额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.unitBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="个人账户余额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.personBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" align="center" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-if="activeName == 'bill'">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" align="center" width="50" label="序号" />
          <el-table-column label="订单号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startChargeSeq }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电桩编码" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.equipmentId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="电站名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.stationName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="运营商名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.operatorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电开始时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电结束时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="充电度数" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.chargingDegree) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="电费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.electricityBill) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务费" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.serviceCharge) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="应付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.payableAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付核对" align="center">
            <template slot-scope="scope">
              <span>{{ getFloat(scope.row.amountReceivable) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实付金额" align="center">
            <template slot-scope="scope">
              <span>{{ getFixed2(scope.row.actualAmount) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div v-if="pageshow" style="float: left;">
        <el-pagination :current-page="currentPage" :page-sizes="[10,20,30,40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script>
// import x from ''
import {
  HOST
} from '@/utils/host'
export default {
  name: 'Cheliangjigoumingxi',
  components: {},
  data() {
    return {
      queryForm: {
        type: 'DAY',
        startTime: '',
        endTime: ''
      },
      isPart: true,
      activeName: 'user',
      detail: {},
      tableData: [],
      currentPage: 1, // 当前页
      total: 0, // 总页数
      pagesize: 10, // 每页条数
      pageshow: true
    }
  },
  computed: {},
  mounted() {
    this.getUserDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 订单状态
    getStatus(e) {
      if (e == 0) {
        return '待支付'
      } else if (e == 1) {
        return '已支付'
      } else {
        return '异常'
      }
    },
    reset() {
      this.queryForm.startTime = ''
      this.queryForm.endTime = ''
    },

    more() {
      const isPart = this.isPart
      if (isPart) {
        this.isPart = false
      } else {
        this.isPart = true
      }
    },

    handleSizeChange(val) {
      this.pagesize = val
      this.currentPage = 1
      if (this.activeName == 'user') {
        this.getUserDetail()
      } else if (this.activeName == 'order') {
        this.getOrderDetail()
      } else if (this.activeName == 'summary') {
        this.getSummaryDetail()
      } else if (this.activeName == 'bill') {
        this.getBillDetail()
      }
    },

    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      if (this.activeName == 'user') {
        this.getUserDetail()
      } else if (this.activeName == 'order') {
        this.getOrderDetail()
      } else if (this.activeName == 'summary') {
        this.getSummaryDetail()
      } else if (this.activeName == 'bill') {
        this.getBillDetail()
      }
    },

    exportOrder() {
      // const orgId = window.localStorage.getItem('curCompanyId');
      const url = HOST + '/finance/manage/export'
      $.fileDownload(url, {
        httpMethod: 'GET',
        data: {
          orgId: this.id,
          timeType: this.queryForm.type,
          startTime: this.queryForm.startTime,
          endTime: this.queryForm.endTime,
          token: window.localStorage.getItem('token'),
          type: 'org'
        },
        failCallback: (html, url) => {
          this.$notify({
            title: '失败',
            message: '导出对账单失败',
            type: 'error'
          })
        }
      })
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.tableData = []
      this.pageshow = false
      this.currentPage = 1
      if (this.activeName == 'user') {
        this.getUserDetail()
      } else if (this.activeName == 'order') {
        this.getOrderDetail()
      } else if (this.activeName == 'summary') {
        this.getSummaryDetail()
      } else if (this.activeName == 'bill') {
        this.getBillDetail()
      }
    },
    handleClick1(tab, event) {
      this.queryForm.type = tab.name
      // this.getUserDetail();
    },
    // 用户列表
    getUserDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/account?type=org',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.orgAndFinanceResp
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    // 订单列表
    getOrderDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/order?type=org',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.orgAndFinanceResp
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    // 财务流水列表
    getSummaryDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/flow?type=org',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.orgAndFinanceResp
          if (resp.billOverviewList) {
            if (resp.billOverviewList.length > 0) {
              this.pageshow = true
              this.tableData = resp.billOverviewList
              console.log(this.tableData)
              this.total = resp.count
            } else {
              this.pageshow = false
            }
          }
        }
      })
    },

    // 对账单列表
    getBillDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/compareBill?type=org',
        data: data,
        method: 'get',
        callback: resp => {
          this.detail = resp.orgAndFinanceResp
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    query() {
      this.tableData = []
      this.currentPage = 1
      if (this.activeName == 'user') {
        this.getUserDetail()
      } else if (this.activeName == 'order') {
        this.getOrderDetail()
      } else if (this.activeName == 'summary') {
        this.getSummaryDetail()
      } else if (this.activeName == 'bill') {
        this.getBillDetail()
      }
    },

    // 去订单详情
    goToDetail(item) {
      this.$router.push({
        path: './orderDetail',
        query: {
          data: item
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less">
.box {
  display: flex;
  height: 140px;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0 20px;
  .company {
    height: 135px;
    font-size: 14px;
    line-height: 25px;
    width: 200px;
    padding:5px 10px;
    border: 1px solid #c9c9c9;
   div{
     width:100%;
   }
  }
  .other-info{
    width:calc(100% - 270px);
    display:flex;
    align-items: center;
    justify-content: space-between;
    height: 135px;
    padding:5px 10px;
    border: 1px solid #c9c9c9;
      div {
      text-align: center;
      .iconfont {
        font-size: 28px;
        font-weight: 600;
      }

      .icon-iconset0216 {
        color: #32F83E;
      }

      .icon-lirunbiao {
        color: #F2E743;
      }
      .icon-yingshouzhangkuan{
        color: #F2E743;
        font-size: 24px;
      }

      .icon-qianbao {
        color: #409eff;
      }

      .icon-qianbao1 {
        color: #409eff;
        font-size: 24px;
      }
      .icon-shishoufeiyong{
        font-size: 30px;
      }
    }
  }
}
.tab_radio{
  .el-radio-button__inner{
    width:82px;
    height:36px;
    line-height: 10px;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner{
    background: #ffffff;
    border: 1px solid #00a6ff;
    color: #00a6ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/flowDetail.vue